import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import "./Changepassword.css";
import CommonButton from "../../../../Componants/Common/Button";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import { Grid } from "@mui/material";
import { changePassword } from "../../../../API Service/apiService";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../../Componants/Loader/Loader";
import DynamicTabs from "../../../../components/DynamicTabs";


import { InputField } from "../../../../Componants/Common/InputField";
import { EyeIcon } from "../../../../Componants/Common/CustomEyeIcon";
const Changepassword = () => {
  const [value, setValue] = useState({});
  const [passwords, setPasswords] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (field, value) => {
    console.log(`Field: ${field}, Value: ${value}`);
    setPasswords((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleChangePassword = async () => {
    const { oldPassword, newPassword, confirmPassword } = passwords;

    // Input Validation
    if (!oldPassword || !newPassword || !confirmPassword) {
      toast.error("All fields are required.");
      // alert("All fields are required.");
      return;
    }

    if (newPassword === oldPassword) {
      toast.error("New password and old password should not be same.");
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(newPassword)) {
      toast.error("Invalid Password Please Check Password Validation");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      // alert("New password and confirm password do not match.");
      return;
    }

    setLoading(true);

    try {
      const response = await changePassword(passwords);
      if (response.status === "success") {
        toast.success(response.message || "Password changed successfully!");
        // alert(response.message || "Password changed successfully!");
        setPasswords({ oldPassword: "", newPassword: "", confirmPassword: "" });
      } else {
        toast.error(response.message || "Failed to change password.");
        // alert(response.message || "Failed to change password.");
      }
    } catch (error) {
      const err = error.response.data.message || "An error occurred while changing the password.";
      console.error("Error during password change:", error);
      toast.error(err);
      // alert("An error occurred while changing the password.");
    } finally {
      setLoading(false);
    }
  };

  const showOldPasswordVisibility = () => {
    setShowOldPassword(true);
  };
  const hideOldPasswordVisibility = () => {
    setShowOldPassword(false);
  };
    const showNewPasswordVisibility = () => {
    setShowNewPassword(true);
  };
      const hideNewPasswordVisibility = () => {
    setShowNewPassword(false);
  };
    const showConfirmPasswordVisibility = () => {
    setShowConfirmPassword(true);
  };
  const hideConfirmPasswordVisibility = () => {
    setShowConfirmPassword(false);
  };

  return (
    <div className="container-Changepassword">
      <HeaderNavigation value={"Change Password"} />
      <DynamicTabs />
      <div className="textfiled-Changepassword">
        <div className="line-Changepassword">
          <div className="textinput-Changepassword" style={{ display: "flex", alignItems: "end", justifyContent: "center",position:"relative" }}>
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="Old Password"
              variant="standard"
              type={showOldPassword ? "text" : "password"}
              value={passwords.oldPassword}
              onChange={(e) => handleInputChange("oldPassword", e.target.value)}
            />
            {/* {
              showOldPassword ? <VisibilityIcon sx={{ marginLeft: "0px", cursor:"pointer" }} onClick={showOldPasswordVisibility} /> : <VisibilityOffIcon sx={{ marginLeft: "0px", cursor:"pointer" }} onClick={showOldPasswordVisibility} />
            } */}
            <EyeIcon
              showPassword={showOldPassword}
              showPasswordVisibility={showOldPasswordVisibility}
              hidePasswordVisibility={hideOldPasswordVisibility}
              position="absolute"
              right="0px"
              top="50%"
              transform="translateY(-50%)"
            />
          </div>
          {/* <InputField
           className="textinput-Changepassword"
           label="Old Password"
           variant="standard"
           type={showOldPassword ? "text" : "password"}
           value={passwords.oldPassword}
           onChange={(e) => handleInputChange("oldPassword", e.target.value)}
           showPassword={showOldPassword}
           showPasswordVisibility={showOldPasswordVisibility}
          /> */}
          <div className="textinput-Changepassword" style={{ display: "flex", alignItems: "end", justifyContent: "center", position:"relative"  }}>
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="New Password"
              variant="standard"
              type={showNewPassword ? "text" : "password"}
              value={passwords.newPassword}
              onChange={(e) => handleInputChange("newPassword", e.target.value)}
            />
            {/* {
              showNewPassword ? <VisibilityIcon sx={{ marginLeft: "0px", cursor:"pointer" }} onClick={showNewPasswordVisibility} /> : <VisibilityOffIcon sx={{ marginLeft: "0px", cursor:"pointer" }} onClick={showNewPasswordVisibility} />
            } */}
            <EyeIcon
              showPassword={showNewPassword}
              showPasswordVisibility={showNewPasswordVisibility}
              hidePasswordVisibility={hideNewPasswordVisibility}
              position="absolute"
              right="0px"
              top="50%"
              transform="translateY(-50%)"
            />
          </div>
          {/* <InputField
           className="textinput-Changepassword"
           label="New Password"
           variant="standard"
           type={showNewPassword ? "text" : "password"}
           value={passwords.newPassword}
           onChange={(e) => handleInputChange("newPassword", e.target.value)}
           showPassword={showNewPassword}
           showPasswordVisibility={showNewPasswordVisibility}
          /> */}

          <div className="textinput-Changepassword" style={{ display: "flex", alignItems: "end", justifyContent: "center", position:"relative" }}>
            {" "}
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="Confirm Password*"
              variant="standard"
              type={showConfirmPassword ? "text" : "password"}
              value={passwords.confirmPassword}
              onChange={(e) =>
                handleInputChange("confirmPassword", e.target.value)
              }
            />
            {/* {
              showConfirmPassword ? <VisibilityIcon sx={{ marginLeft: "0px", cursor:"pointer" }} onClick={showConfirmPasswordVisibility} /> : <VisibilityOffIcon sx={{ marginLeft: "0px", cursor:"pointer" }} onClick={showConfirmPasswordVisibility} />
            } */}
            <EyeIcon
              showPassword={showConfirmPassword}
              showPasswordVisibility={showConfirmPasswordVisibility}
              hidePasswordVisibility={hideConfirmPasswordVisibility}
              position="absolute"
              right="0px"
              top="50%"
              transform="translateY(-50%)"
            />
          </div>
          {/* <InputField
           className="textinput-Changepassword"
           label="Confirm Password*"
           variant="standard"
           type={showConfirmPassword ? "text" : "password"}
           value={passwords.confirmPassword}
           onChange={(e) => handleInputChange("confirmPassword", e.target.value)}
           showPassword={showConfirmPassword}
           showPasswordVisibility={showConfirmPasswordVisibility}
          /> */}
        </div>
        <Grid container sx={{ margin: "10px" }}>
          <CommonButton
            name={"Change Password"}
            handleOnClick={handleChangePassword}
          />
        </Grid>
        <div className="password-note">
          <p>* Minimum 8 characters</p>
          <p>* At least one uppercase letter</p>
          <p>* At least one lowercase letter</p>
          <p>* At least one numeric digit</p>
          <p>* At least one special character</p>
        </div>

        <div className="button-Changepassword">
          <div className="textinput-Changepassword"></div>
        </div>
      </div>
      <Toaster />
      {loading && <Loader />}
    </div>
  );
};

export default Changepassword;
